var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 11.79C16.0121 11.12 16.5814 10.02 16.5814 9C16.5814 6.74 15.1163 5 13.2326 5H8V19H13.894C15.6437 19 17 17.3 17 15.21C17 13.69 16.28 12.39 15.2 11.79ZM10.5116 7.5H13.0233C13.7181 7.5 14.2791 8.17 14.2791 9C14.2791 9.83 13.7181 10.5 13.0233 10.5H10.5116V7.5ZM13.4419 16.5H10.5116V13.5H13.4419C14.1367 13.5 14.6977 14.17 14.6977 15C14.6977 15.83 14.1367 16.5 13.4419 16.5Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.80ad518d703d2d87ed0426111858d70c.svg";
export { ForwardRef as ReactComponent };